import React from 'react';
import classnames from 'classnames';
import * as styles from './styles.module.scss';

import QuestionsSwiper from './components/QuestionsSwiper';

const Questions = ({ data }) => (
  <div className={styles.questions}>
    <div className={classnames('cr-wrap', styles.questions_inner)}>
      <span className={styles.questions_inner_bg_1}></span>
      <span className={styles.questions_inner_bg_2}></span>

      <div className={styles.questions_inner_head}>
        <div>
          <p
            className={classnames(
              'cr-subheader cr-main',
              styles.questions_txt_suptitle
            )}
          >
            {data.title}
          </p>

          <h2 className={classnames('cr-h2 cr-white')}>{data.subtitle}</h2>
        </div>
      </div>

      <div className={styles.questions_inner_img}>
        <div className={styles.questions_img}></div>
      </div>

      <div className={styles.questions_inner_swiper}>
        <QuestionsSwiper slides={data.slides} />
      </div>
    </div>
  </div>
);

export default Questions;
